<template>
  <div class="bg-re1d-200">
    <template v-if="editMode && !disabled">
      <div class="h-full py-[2px] relative">
        <a-tooltip
          :title="err"
          :visible="!!err"
          placement="topLeft"
          overlay-class-name="editabletitle-error"
          :overlay-style="{ color: '#F00' }"
        >
          <!-- class="h-full w-full border border-white border-solid bg-transparent outline-none text-normal" -->
          <input
            ref="input"
            v-model="inputVal"
            :spellcheck="false"
            autofocus
            class="h-full w-full bg-black-50 border-solid border border-black outline-none text-normal input-text-color"
            :class="{
              'border-red-400': !!err
            }"
            @keyup.enter="submitAndClose"
            @blur="submitAndClose"
            @input="_valid"
            @focus="focus"
          />
        </a-tooltip>
      </div>
    </template>
    <template v-else>
      <div
        class="overflow-hidden flex items-center h-full text-ellipsis max-w-[180px] whitespace-nowrap"
        :class="{
          'justify-center': center
        }"
        @dblclick="
          (e) => {
            if (disabled) return;
            startEditMode();
            e.stopPropagation();
          }
        "
      >
        <span
          v-for="(item, index) in Array.from(inputVal)"
          :key="index"
          :style="{
            color:
              _highlightText &&
              inputVal.toLocaleLowerCase()?.includes(_highlightText) &&
              _highlightText?.includes(item?.toLocaleLowerCase() ?? '')
                ? '#2094FF'
                : ''
          }"
          >{{ item }}</span
        >
        <slot />
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, nextTick, PropType, ref, watch } from 'vue';

const props = defineProps({
  treeId: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  submit: {
    type: Function as PropType<(treeId: string, value: string) => void>,
    default: () => ({})
  },
  valid: {
    type: Function as PropType<
      (treeId: string, value: string) => string | undefined
    >,
    default: undefined
  },
  center: {
    type: Boolean,
    default: false
  },
  editKey: {
    type: Number,
    default: 0
  },
  disabled: {
    type: Boolean,
    default: false
  },
  highlightText: {
    type: String,
    default: undefined
  }
});

const _highlightText = computed(
  () => props.highlightText?.toLocaleLowerCase() ?? ''
);

// input
const input = ref<HTMLInputElement>();
const inputVal = ref(props.title);
const editMode = ref(false);

const emits = defineEmits<{
  (event: 'valid', treeId: string, valid: boolean): void;
}>();

// error
const err = ref('');
watch(err, () => {
  const valid = !err.value;
  emits('valid', props.treeId, valid);
});

const _valid = () => {
  const errMsg = props.valid?.(props.treeId, inputVal.value) ?? '';
  err.value = errMsg;
  const valid = !errMsg;
  return valid;
};

const submitAndClose = () => {
  if (editMode.value == false) return;
  // 验证名称
  if (_valid()) {
    // 验证通过修改
    props.submit?.(props.treeId, inputVal.value);
  } else {
    inputVal.value = props.title;
  }
  // 关闭编辑模式
  editMode.value = false;
  err.value = '';
};

watch(
  () => props.editKey,
  (val) => {
    if (val > 0) startEditMode();
    if (val < 0) submitAndClose();
  }
);

watch(
  () => props.title,
  () => {
    inputVal.value = props.title;
  }
);

const startEditMode = async () => {
  if (props.disabled) return;
  err.value = '';
  editMode.value = true;
  inputVal.value = props.title;
  await nextTick();
  // inputVal.value = data.title;
  input.value?.focus();
};
defineExpose({ startEditMode });

function focus() {
  input.value?.setSelectionRange(0, input.value.value.length);
}
</script>
<style lang="less">
.editabletitle-error .ant-tooltip-inner {
  color: #f00;
  font-weight: 500;
}
.input-text-color::selection {
  color: #c2ddfb;
  background: #2559c9;
}
</style>
